import 'src/utils/polyfills';

import invariant from 'invariant';
import * as React from 'react';
import {createRoot} from 'react-dom/client';

import {bootstrapSentry} from 'src/client/bootstrap-sentry';
import {bootstrapStores} from 'src/client/bootstrap';

import ErrorBoundary from 'src/components/500/boundary';
import ContentSubscriptionApp from 'src/components/content-subscription/app';


const {reduxStore, store, env} = bootstrapStores();

bootstrapSentry(env);

const appElement = document.getElementById('app');
invariant(appElement, 'Could not render without an #app.');

let trackingId, sentEventId;
//Note(Vish): For J2 Emails, we are using tracking-id instead of sentEventId.
if (window.location.pathname.indexOf('tracking-id') !== -1) {
  const [_empty, _cs, _manage, _tid, _trackingId] =
    window.location.pathname.split('/');
  trackingId = _trackingId;
  invariant(trackingId, 'Could not render without a trackingId.');
} else {
  const [_empty, _cs, _manage, _sentEventId] =
    window.location.pathname.split('/');
  sentEventId = _sentEventId;
  invariant(sentEventId, 'Could not render without a sentEventId.');
}

const urlParams = new URLSearchParams(window.location.search);
const unsubscribeCategoryId = urlParams.get('unsubscribe_category_id');
const attributeName = urlParams.get('attribute_name');
const attributeValue = urlParams.get('attribute_value');

const root = createRoot(appElement);
root?.render(
  <ErrorBoundary>
    <ContentSubscriptionApp
      unsubscribeCategoryId={unsubscribeCategoryId ?? ''}
      attributeName={attributeName ?? ''}
      attributeValue={attributeValue ?? ''}
      sentEventId={sentEventId}
      reduxStore={reduxStore}
      senseStore={store}
      trackingId={trackingId}
    />
  </ErrorBoundary>,
);
